// src/components/TopHeader.tsx
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import logo from "../assets/log.png"; // adjust if logo is elsewhere
import { useBreadcrumbContext } from "../context/BreadcrumbContext";
import Breadcrumb from "../components/Breadcrumb";

const TopHeader = () => {
    const { t } = useTranslation();
    const { items } = useBreadcrumbContext();
    const hasBreadcrumb = items.length > 0;
    return (
        <div className="d-flex align-items-center px-4 py-2 border-bottom bg-white" style={{ height: '10vh', gap: '1.5rem' }}>
            <Link to="/" className="d-flex align-items-center" style={{ textDecoration: 'none' }}>
                <img src={logo} alt={t('topheader.logo_alt')} style={{ height: "10vh", cursor: 'pointer' }} />
            </Link>
            {hasBreadcrumb && (
                <>
                    <div style={{ width: 1, height: '40%', backgroundColor: '#e0e0e0' }} />
                    <div style={{ flex: 1, minWidth: 0 }}>
                        <Breadcrumb items={items} />
                    </div>
                </>
            )}
        </div>
    );
};

export default TopHeader;
